<h1 mat-dialog-title>Delete callback location?</h1>
<mat-dialog-content>
  <p>{{ data.name }} will be removed from this organization.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>
